import { render, staticRenderFns } from "./IndexGoods.vue?vue&type=template&id=36347486&scoped=true&"
import script from "./IndexGoods.vue?vue&type=script&lang=js&"
export * from "./IndexGoods.vue?vue&type=script&lang=js&"
import style0 from "./IndexGoods.vue?vue&type=style&index=0&id=36347486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36347486",
  null
  
)

export default component.exports